// core imports/libs
import 'rails-ujs';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@fortawesome/fontawesome-free/css/all';

// components imports
import '../../../components/search_bar/component_controller';
import '../../../components/navbar/component_controller';
import '../../../components/line_prices_box/component_controller';
import '../../../components/full_itinerary/component_controller';
import '../../../components/board_information/component_controller';

// css imports
require('../../style/application');
require('../../style/search');
